// extracted by mini-css-extract-plugin
export default {"formWrapper":"ParamsModal_formWrapper__AHB0N"};